'use client';

import { ErrorView } from '../../../overrides/components/nt/forms-pages/error-view';

/** Runtime errors below the layout (header and footer stay): the NajTonery error card. */
export default function LocaleError({ error, retry }: { error: unknown; retry: () => void }) {
  return <ErrorView error={error} retry={retry} />;
}
